import React, { Component } from "react";
import { ExcelRenderer } from "react-excel-renderer";
import ReactTable from "react-table";
import axios from "axios";
import { PodSaveReq } from "../FacadesJson/PodSaveReq";
// import "../../assets/css/print.css";
// import "../../assets/css/loader.css";
import Select from "react-select";
//import { Select } from "react-inputs-validation";
import "../assets/css/print.css";
import "../assets/css/loader.css";
import SweetAlert from "react-bootstrap-sweetalert";
import swal from "sweetalert";
import HmacSHA256 from "crypto-js/hmac-sha256";
import { CSVLink } from "react-csv";
//import LoadingSpinner from "../../components/Input/LoadingSpinner";
import LoadingSpinner from "../components/Input/LoadingSpinner";
import $ from "jquery";
//import "../../../src/assets/css/loader.css";
import ReactFileReader from 'react-file-reader';


const Rounds = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
];


class SortoKorrierKonvenier extends Component {
  state = {
    rows1: [],
    rapFacade: [],
    rapFacadeNew: [],
    kodSherbimiP: "",
    kodSherbimiDK: "",
    statusi: [],
    korrier: [],
    kategori: [],
    podi: [],
    sortpodi:[],
    cmimi: [],
    Token: "",
    Username: "",
    error1: "",
    alert: null,
    showModal: false,
    loading: false,
    postsexcel: [],
    lastround: "",
    selectedround: "",
    roundoptions: [],
    sorted: false,
    showData: false,
  };

  showModal = () => {
    this.setState({ showModal: true });
  };
  hideModal = () => {
    this.setState({ showModal: false });
  };

  hideAlert() {
    this.setState({
      alert: null,
    });  
  }

   deleteThisGoal2() {
    const getAlert = () => (
      <SweetAlert
        success
        title="Sukses!"
        closeOnClickOutside={false}
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        showCancel
      >
        {this.state.error1}
      </SweetAlert>
    );

    this.setState({
      alert: getAlert(),
    });
  }

  onClearInput = () => {
    // this.setState({
    //   rows1: [],
    //   rapFacade: [],
    //   error1: "",
    //   showModal: false,
    //   loading: false,
    //   rows: [],
    // });
    window.location.reload();
  };

  handleClickModal = (e) => {
    var posts = [...this.state.posts];
    posts.push(this.state.njesi);
    this.setState({ posts: posts, cope: posts.length + 1 });
  };

  convert = (par) => {
    par.forEach((element) => {
    if (element[0]!= "" && element[0]!= undefined)
    {
        var rowPost = new PodSaveReq();
        
        rowPost.PODNr = element[0]
        .toString()
        .toUpperCase()
        .trim();

      
        if(element[1]!= undefined)
        {
          rowPost.Korrieri = element[1].toString().trim();
        }
        else{
          rowPost.Korrieri = "";
        }

        if(element[2]!= undefined)
        {
          rowPost.KodPershkrimi = element[2].toString().trim();
        }
        else{
          rowPost.KodPershkrimi = "";
        }

        //rowPost.KlientSubjektID = window.UserP.ClientSubjectID;

        // rowPost.Token = HmacSHA256(
        //     Math.round(new Date().getTime / 1000).toString(),
        //     window.UserP.key
        // ).toString();
      
        // rowPost.username = window.UserP.username;
        

        this.state.rapFacade.push(rowPost);
    }
    element++;
    });

    this.setState({ 
      rapFacade: this.state.rapFacade,
      });
  };

   csvJSON(csv){
     console.log(csv);
    var lines=csv.split("\n");

    lines.shift();
    //console.log(lines);
    var result = [] ;
  
    // NOTE: If your columns contain commas in their values, you'll need
    // to deal with those before doing the next step 
    // (you might convert them to &&& or something, then covert them back later)
    // jsfiddle showing the issue https://jsfiddle.net/
   // var headers=lines[0].split(",");
  
    for(var i=0;i<lines.length;i++){
  
        var obj = {};
        var currentline=lines[i].split(',');
        console.log(currentline);
        // for(var j=0;j<headers.length;j++){
        //     obj[headers[j]] = currentline[j];
        // }

        if(currentline[0] != undefined && currentline[0] != "" )
        {
          var rowPost = new PodSaveReq();

          rowPost.PODNr =  currentline[0].toString().trim().replace(/['"]+/g, ''); 

           let korrier = "";
           if (currentline[1] != undefined )
            {
              rowPost.Korrieri =  currentline[1].toString().trim().replace(/['"]+/g, ''); //element[1].toString().toUpperCase(); 
              korrier = rowPost.Korrieri
            }
            else
            {
              rowPost.Korrieri = "";
            }
            this.state.korrier.push(korrier);

            let kategori = "";
           if (currentline[2] != undefined)
            {
              rowPost.KodPershkrimi =  currentline[2].toString().trim().replace(/['"]+/g, ''); //element[1].toString().toUpperCase(); 
              kategori = rowPost.KodPershkrimi
            }
            else
            {
              rowPost.KodPershkrimi = "";
            }
            this.state.kategori.push(kategori);
            
        
            rowPost.KlientSubjektID = window.UserP.ClientSubjectID;
            rowPost.Token = HmacSHA256(
              Math.round(new Date().getTime / 1000).toString(),
              window.UserP.key
            ).toString();
        
            rowPost.username = window.UserP.username;
            
            this.state.rapFacade.push(rowPost);
        
            result.push(obj);
        }
       
  
    }
    this.setState({ 
      rapFacade: this.state.rapFacade,
      korrier: this.state.korrier,
      kategori: this.state.kategori
     });
   // this.convert(obj);
    //return result; //JavaScript object
   // return JSON.stringify(result); //JSON
     console.log(this.state.rapFacade);
  }

    handleFiles = files => {
    let reader = new FileReader();
    if( this.state.showData ==true)
    {
        swal("Ju lutem regjistroni ose pastroni filen qe keni ngarkuar!")
      
        return
    } 
    reader.onload = () => {
      // Use reader.result
    //   this.setState({
    //     csvData: reader.result
    //   })
      this.csvJSON(reader.result)
     
    }
    reader.readAsText(files[0]);

    this.setState({showData:true})
   
  }

  onChangeFunc = (name) => (value) => {
    this.setState({
      [name]: value,
    });
  };

  handleClickSort = (e) => {
    if (this.state.showData == false) {
      swal("Ju lutem zgjidhni filen excel qe doni te ngarkoni!");
    } else {
      //this.convert(this.state.rows);
       
      var postsnew = [];
      postsnew= this.state.rapFacade;
      console.log(postsnew);

      const req = {
        array: postsnew,
        Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
        username: window.UserP.username,
      }

      $("cover-spin").show();
      this.setState({ loading: true }, () => {
        axios
          .post(window.UserP.url + "POD/SortKorrierPod", req)
          .then((response) => {
            this.setState({korrier: [], kategori: []});
            for (var i in response.data) {
              let korrier = response.data[i].Korrieri;
              this.state.korrier.push(korrier);

               let kategori = response.data[i].Kategoria;
              this.state.kategori.push(kategori);

              const dataexcel = {
                POD: response.data[i].PodNo,
                Korrieri: korrier,
                Kategoria: kategori
              }

              this.state.postsexcel.push(dataexcel);
             
            }

            this.setState({
                    loading: false,
                    showModal: true,
                    sorted: true,
                    postsexcel: this.state.postsexcel,
                    korrier: this.state.korrier,
                    kategori: this.state.kategori,
                    error1: "Korrieret u sortuan, ju lutem vijoni me ruajtjen!" 
                  });

            this.deleteThisGoal2();
          })
          .catch((error) => {
            alert(error + " Ju lutem kontaktoni departamentin e IT!");
          });
      });

      console.log(this.state.postsexcel);

      return this.state.korrier;

      

      
    }
  };

  handleClick = (e) => {
    if (this.state.showData == undefined) {
      swal("Ju lutem zgjidhni filen excel qe doni te ngarkoni!");
    } else {
       var postsnew = [];
      if (this.state.sorted == false)
      {
        //this.convert(this.state.rows);
        postsnew= this.state.rapFacade
      }
      else
      {
        //var rapFacadeNew = [];
        for (var i in this.state.postsexcel)
        {
          var rowPost = new PodSaveReq();

        rowPost.PODNr = this.state.postsexcel[i].POD
        .toString()
        .toUpperCase()
        .trim();
      
          rowPost.Korrieri = this.state.postsexcel[i].Korrieri
        .toString()
        .toUpperCase()
        .trim();

          rowPost.KodPershkrimi = this.state.postsexcel[i].Kategoria
        .toString()
        .toUpperCase()
        .trim();
        

        this.state.rapFacadeNew.push(rowPost);
        }
       this.setState({ 
      rapFacadeNew: this.state.rapFacadeNew,
      });

      postsnew= this.state.rapFacadeNew;
      
      }
      
      console.log(postsnew);

      const req = {
        array: postsnew,
        Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
        username: window.UserP.username,
      }

      $("cover-spin").show();
      this.setState({ loading: true }, () => {
        axios
          .post(window.UserP.url + "POD/UpdateKorrierPod", req)
          .then((response) => {

            this.setState({postsexcel: []});
            for (var i in response.data) {
              let statusi = response.data[i].Status;
              
              this.state.statusi.push(statusi);

              const dataexcel1 = {
                POD: response.data[i].PodNo,
                Korrieri: response.data[i].Korrieri,
                Kategoria: response.data[i].Kategoria,
                Mesazhi: statusi
              }

              this.state.postsexcel.push(dataexcel1);
             
            }

            this.setState({
                    loading: false,
                    postsexcel: this.state.postsexcel
                  });

            //if (this.state.podi.length == 0) {
            //   this.setState({
            //     loading: false,
            //     showModal: true,
            //     error1: "Mesazhet u derguan!",
            //   });
            //} else {
            //   this.setState({
            //     loading: false,
            //     showModal: true,
            //     error1:
            //       "Gabim! Podet e meposhtme nuk jane modifikuar." +
            //       this.state.podi,
            //   });
            // }
          })
          .catch((error) => {
            alert(error + " Ju lutem kontaktoni departamentin e IT!");
          });
      });
      return this.state.statusi;
    }
  };

  handleClickUpdateRound = (e) => {

    if (this.state.selectedround == null || this.state.selectedround == "" || this.state.selectedround == undefined)
    {
      this.setState({
        showModal: true,
        error1: "Ju lutem zgjidhni Raundin"
      });

      this.deleteThisGoal2();
    }
    else
    {
      const req = {
        round: this.state.selectedround.label,
        Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
        username: window.UserP.username,
      }

      $("cover-spin").show();
      this.setState({ loading: true }, () => {
        axios
          .post(window.UserP.url + "POD/UpdateRound", req)
          .then((response) => {
            
            if (response.data.Result == false)
            {
              this.setState({
                    loading: false,
                    showModal: true,
                    lastround: response.data.ResultMessageCheck,
                    error1: response.data.ResultMessage
                  });

                this.deleteThisGoal2();
            }

            else
            {
              this.setState({
                    loading: false,
                    lastround: response.data.ResultMessageCheck,
                  });
            }

            
          })
          .catch((error) => {
            alert(error + " Ju lutem kontaktoni departamentin e IT!");
          });
      });
      return this.state.lastround;
    }
    
  };

  remove(array, element) {
    return array.filter((el) => el.length != element);
  }

    convertToDropDown = (par) => {
    var ret = [];
    var paramArray = par;

    for (var i in paramArray) {
      var objItem = { value: "", label: "" };
      objItem.value = paramArray[i];
      objItem.label = paramArray[i];
      ret.push(objItem);
    }

    return ret;
  };


  fileHandler = (event) => {
    //  console.log(this.state.rapFacade);

    let fileObj = event.target.files[0];

    //just pass the fileObj as parameter
    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
      } else {
        
        var res = this.remove(resp.rows, 0);
        res.shift();
        
        for(var i=0;i<res.length;i++ )
          {
            let korrier = "";
            if (res[i][1] != undefined)
            {
              korrier = res[i][1].toString();
            }
            this.state.korrier.push(korrier);

            let kategori = "";
            if (res[i][2] != undefined)
            {
              kategori = res[i][2].toString();
            }
            this.state.kategori.push(kategori);

          }
         this.setState({
          korrier: this.state.korrier,
          kategori: this.state.kategori
        });

        
        var col = [];
        col.push(resp.cols[0]);
        col.push(resp.cols[1]);
        

        this.setState({
          //cols: resp.cols,
          cols: col,
          rows: res,
        });

      }
    });
  };

  componentWillMount() {

    fetch(window.UserP.url + "POD/GetCurrentRound", {
      method: "Post",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        Token: HmacSHA256(
          Math.round(new Date().getTime() / 1000).toString(),
          window.UserP.key
        ).toString(),
        username: window.UserP.username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
      
      this.setState({ lastround: data});
    
      });

      fetch(window.UserP.url + "POD/GetNumberOfRounds", {
      method: "Post",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        Token: HmacSHA256(
          Math.round(new Date().getTime() / 1000).toString(),
          window.UserP.key
        ).toString(),
        username: window.UserP.username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
      
      this.setState({ roundoptions: data});
    
      });
  }

  

  render() {
    const columns = [
      {
        Header: "POD",
        accessor: "PODNr",
        width: 400,
        
      },
      {
        Header: "Korrieri",
        accessor: "Korrieri",
        width: 500,
        Cell: (korrier) => (
          <span className="number">{this.state.korrier[korrier.index]}</span>
        ),
      },
      {
        Header: "Kategoria",
        accessor: "Kategoria",
        width: 100,
        Cell: (kategori) => (
          <span className="number">{this.state.kategori[kategori.index]}</span>
        ),
      },
      {
        Header: "Status",
        accessor: "2",
        width: 500,
        Cell: (statusi) => (
          <span className="number">{this.state.statusi[statusi.index]}</span>
        ),
      },
    ];

    return (
      <div className="card card-body bg-light col-md-12">
        <div className="row">
       
         {/* <div className="col-md-4">
          <input
            type="file"
            className="btn btn-default"
            onChange={this.fileHandler.bind(this)}
            style={{ padding: "10px" }}
          />
          </div>  */}
           <div className="col-md-4">
              <ReactFileReader handleFiles={this.handleFiles} fileTypes={'.csv'}  >
                 <button className="btn btn-default">Upload </button>
          </ReactFileReader>
          </div>

          <div className="col-md-2">
            <label className="m-2">Raundi Aktual</label>
            <input
            id="2"
            className="form-control "
            type="text"
            name="lastround"
            value={this.state.lastround}
            disabled={true}
            />
            </div>

          <div className="col-md-2">
            <label className="m-2">Raundi i Ri</label>
            <Select
              id="4"
              className="custom-Select"
              onChange={this.onChangeFunc("selectedround")}
              options={this.convertToDropDown(this.state.roundoptions)}
              value={this.state.selectedround}
              required
            />
          </div>

          <div className="col-md-2">
            <button
              className="btn btn-primary mt-4"
              onClick={(e) => this.handleClickUpdateRound(e)}
            >
              <span data-notify="icon" className="pe-7s-diskette" />
              &nbsp; Perditeso Raundin
            </button>
          </div>

         
        </div>
        
        <div>
          {this.state.loading ? (
            <LoadingSpinner />
          ) : (
            <ReactTable
              columns={columns}
              data={this.state.rapFacade}
              defaultPageSize={10}
              className="-striped -highlight mt-4"
              pageText="Faqe"
              nextText="Para"
              rowsText="Rreshta"
              previousText="Mbrapa"
              noDataText="Nuk ka te dhena"
            />
          )}
        </div>

        <div className="row">
          <div className="ml-4">
            <button
              className="btn btn-primary mt-4"
              disabled={this.state.loading}
              onClick={(e) => this.handleClickSort(e)}
            >
              <span data-notify="icon" className="pe-7s-diskette" />
              &nbsp; Sorto
            </button>
          </div>
          <div className="mt-4">
            <CSVLink className="ml-4" data={this.state.postsexcel}>
              <span data-notify="icon" className="pe-7s-download" />
              &nbsp; Eksporto
            </CSVLink>
          </div>
          <div className="ml-4">
            <button
              className="btn btn-primary mt-4"
              disabled={this.state.loading}
              onClick={(e) => this.handleClick(e)}
            >
              <span data-notify="icon" className="pe-7s-diskette" />
              &nbsp; Ruaj
            </button>
          </div>
          <div>
            {this.state.showModal ? (
              <div>
                <ModalTSh
                  showModal={this.state.showModal}
                  handleClose={this.hideModal}
                  className="modal fade docs-example-modal-sm"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="mySmallModalLabel"
                  aria-hidden="true"
                >
                  <div className="row">
                    <div className="col-md-9 ml-auto">{this.state.error1}</div>
                  </div>
                </ModalTSh>
              </div>
            ) : null}
          </div>
          <div className="col md-6 mt-4">
            <button
              className="btn btn-primary float-right"
              onClick={() => this.onClearInput()}
            >
              <span data-notify="icon" className="pe-7s-trash" />
              &nbsp; Pastro
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export const ModalTSh = ({ handleClose, showModal, children }) => {
  const showHideClassName = showModal
    ? "modal display-block"
    : "modal display-none";

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        {children}
        <button className="btn btn-primary btn-sm m-2" onClick={handleClose}>
          Mbyll
        </button>
      </section>
    </div>
  );
};
export default SortoKorrierKonvenier;
